import moment from 'moment'

class DateUtils {

    static formatDate ( date ) {



        let result = ''
        if( date.getDate()<10 ) {
            result = '0'+date.getDate()
        }else{
            result = date.getDate()
        }
        result += '/'
        if( date.getMonth()<10 ) {
            result += '0' + (date.getMonth()+1)
        } else {
            result += date.getMonth()
        }
        result += '/'+date.getFullYear()

        return result
    }

    static dateStrToDate (dateStr) {
        const d = dateStr.substr(0, 2)
        const m = parseInt( dateStr.substr(3, 2)-1, 10)
        const y = dateStr.substr(6, 4)
        return new Date(y, m, d)
    }

    
    static dateTimeStrToDate (dateStr) {
        const d = dateStr.substr(0, 2)
        const m = parseInt( dateStr.substr(3, 2)-1, 10)
        const y = dateStr.substr(6, 4)
        const hh = dateStr.substr(11, 2)
        const mm = dateStr.substr(14, 2)
        return new Date(y, m, d, hh, mm)
    }

    static getWeekArray () {

        var startOfWeek = moment().startOf('isoWeek')
        var endOfWeek = moment().endOf('isoWeek')
        
        var days = []
        var day = startOfWeek
        
        while (day <= endOfWeek) {
            days.push(day.format('DD/MM/YYYY'))
            day = day.clone().add(1, 'd')
        }
        
        return days
    }

    static getHoursArray () {
        const result = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23']
        return result
    }
    
    static getMonthStr (monthNum) {
        switch(monthNum) {          
            case 1:
                return "ENERO"
            case 2:
                return "FEBRERO"
            case 3:
                return "MARZO"
            case 4:
                return "ABRIL"
            case 5:
                return "MAYO"
            case 6:
                return "JUNIO"
            case 7:
                return "JULIO"
            case 8:
                return "AGOSTO"
            case 9:
                return "SEPTIEMBRE"
            case 10:
                return "OCTUBRE"
            case 11:
                return "NOVIEMBRE"
            case 12:
                return "DICIEMBRE"
            default:
                return ""
        }
    }

}

export default DateUtils